import { Component } from 'react';
import Stress from './healthRisksTabs/Stress'
import Smoking from './healthRisksTabs/Smoking'
import Alcohol from './healthRisksTabs/Alcohol'
import Diet from './healthRisksTabs/Diet'
import Exercise from './healthRisksTabs/Exercise'
import Hypertensive from './healthRisksTabs/Hypertensive'
import Diabetic from './healthRisksTabs/Diabetic'
import Cvd from './healthRisksTabs/Cvd'
import Weight from './healthRisksTabs/Weight'
import { Row, Tabs, Col, Spin, Tooltip } from 'antd';
import { SingleHeartImage, download_btn, greenTickThick } from '../../assets/images';
import { Breadcrumb } from '../common/atoms';
import { Tabbar } from '../common/molecules';
import ContractsManager from '../../managers/ContractsManager';
import { analyticsApi, utilizationApi } from '../../services';
import axios from 'axios';
import { handleAppError } from '../handlers';
import { Modal } from '../modals';
import { dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';
let token = '';


const TabPane = Tabs.TabPane;

class HealthRisks extends Component {
  constructor(props) {
      super(props);
      this.state = {
        loading: false,
        data: {},
        tabLoading: false,
        metricObj : {},
        contractId : null,
        selectedContractObj: {},
        showModal: false,
      };
  }

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'HRA-analytics');
        this.setState({ metricObj :  contractObj, contractId : contractObj.formattedData[0].contract_id,
                        startDate: contractObj.formattedData[0].start_date, endDate: contractObj.formattedData[0].end_date,
                        selectedContractObj: contractObj.formattedData[0] });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  downloadHra = () => {
    analyticsApi.downloadHraReport({},
      (resp)=>{
        console.log('resp',resp)
        this.setState({ showModal: true });
      },
      (err)=>{
        handleAppError(err)
      })
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();
    const lifestyle = analyticsApi.getLifestyle({ contractId, startDate, endDate, cancelToken: token.token })
    const conditions = analyticsApi.getConditions({ contractId, startDate, endDate, cancelToken: token.token })

    Promise.all([lifestyle, conditions])
      .then((responses) => {
        responses = responses.map((resp) => resp.data)
        this.setState({ data: {...responses[0], ...responses[1]}, loading: false, tabLoading: false })
      })
      .catch(err => {
        handleAppError(err)
        this.setState({ tabLoading: false })
      })
  }

  componentDidMount () {
    this.fetchContractDetails();
    this.setState({loading: true})
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate);
    }
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  changeContractId = (contract) => {
    const { contractId }  = this.state
    const { contract_id, start_date, end_date } = contract;
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        tabLoading: true,
      });
    } else if (contract.text === 'Overall') {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        tabLoading: false,
      });
    }
  }
  renderPopoverContent(num,total,text,color,type){
    return(
      <div>
        <Row type="flex" justify="start">
          <h5 style={{color: '#ffffff'}}>
            <span style={{color: color}}>{num ?? 0}&nbsp;</span>
            <span style={{color: '#9CA3AF'}}>{text} out of&nbsp;</span>
            {total}
            <span style={{color: '#9CA3AF'}}>{` users who provided ${type} data`}</span>
          </h5>
        </Row>
      </div>
    )
  }

  renderPopoverContentNoData(text){
    return(
      <div>
        <Row type="flex" justify="start">
          <h5 style={{color: '#ffffff'}}>{text}</h5>
        </Row>
      </div>
    )
  }

  renderSvgCircleProgress(c1,c2,c3,c4,c5,c1_text,c2_text,c3_text,c4_text,c5_text,c1_no_text,c2_no_text,c3_no_text,c4_no_text,c5_no_text,no_data, c1_type, c2_type, c3_type, c4_type, c5_type){
    let c1_percent = c1[0]*100/c1[1]
    let c2_percent = c2[0]*100/c2[1]
    let c3_percent = c3[0]*100/c3[1]
    let c4_percent = c4[0]*100/c4[1]
    let c5_percent = c5[0] === "condition" ? 0 : c5[0]*100/c5[1]
    let c1_array = [c1_percent.toFixed(0),100]
    let c2_array = [c2_percent.toFixed(0),100]
    let c3_array = [c3_percent.toFixed(0),100]
    let c4_array = [c4_percent.toFixed(0),100]
    let c5_array = [c5_percent.toFixed(0),100]
    let class_name1 = (c1_percent === 0 || isNaN(c1_percent)) ? ["circular-chart grey","percentage-green",'#4FAD96'] : ["circular-chart red","percentage",'#F17B6E']
    let class_name2 = (c2_percent === 0 || isNaN(c2_percent)) ? ["circular-chart grey","percentage-green",'#4FAD96'] : ["circular-chart red","percentage",'#F17B6E']
    let class_name3 = (c3_percent === 0 || isNaN(c3_percent)) ? ["circular-chart grey","percentage-green",'#4FAD96'] : ["circular-chart red","percentage",'#F17B6E']
    let class_name4 = (c4_percent === 0 || isNaN(c4_percent)) ? ["circular-chart grey","percentage-green",'#4FAD96'] : ["circular-chart red","percentage",'#F17B6E']
    let class_name5 = (c5_percent === 0 || isNaN(c5_percent)) ? ["circular-chart grey","percentage-green",'#4FAD96'] : ["circular-chart red","percentage",'#F17B6E']
    return(
      <div>
        <div className="flex-wrapper">
          { isNaN(c1_percent) ?
          <div className="single-chart">
            <Tooltip title={this.renderPopoverContentNoData(no_data)}>
            <svg viewBox="0 0 36 36" className={class_name1[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c1_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="20.35" className="percentage-text" style={{fill: '#9CA3AF'}}>{c1_no_text}</text>
            </svg>
            </Tooltip>
          </div>
          :
          <div className="single-chart">
            <a>
            <Tooltip title={this.renderPopoverContent(c1[0],c1[1],c1_text,class_name1[2], c1_type)}>
            <svg viewBox="0 0 36 36" className={class_name1[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c1_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="16.35" className={class_name1[1]}>{c1_array[0] + '%'}</text>
              <text x="18" y="20.35" className="percentage-text">{c1_text}</text>
            </svg>
            </Tooltip>
            </a>
          </div>
          }
          {isNaN(c2_percent) ?
          <div className="single-chart">
            <Tooltip title={this.renderPopoverContentNoData(no_data)}>
            <svg viewBox="0 0 36 36" className={class_name2[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c2_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="20.35" className="percentage-text" style={{fill: '#9CA3AF'}}>{c2_no_text}</text>
            </svg>
            </Tooltip>
          </div>
          :
          <div className="single-chart">
            <a>
            <Tooltip title={this.renderPopoverContent(c2[0],c2[1],c2_text,class_name2[2], c2_type)}>
            <svg viewBox="0 0 36 36" className={class_name2[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c2_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="16.35" className={class_name2[1]}>{c2_array[0] + '%'}</text>
              <text x="18" y="20.35" className="percentage-text">{c2_text}</text>
            </svg>
            </Tooltip>
            </a>
          </div>
          }
          {isNaN(c3_percent) ?
          <div className="single-chart">
            <Tooltip title={this.renderPopoverContentNoData(no_data)}>
            <svg viewBox="0 0 36 36" className={class_name3[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c3_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="20.35" className="percentage-text" style={{fill: '#9CA3AF'}}>{c3_no_text}</text>
            </svg>
            </Tooltip>
          </div>
          :
          <div className="single-chart">
            <a>
            <Tooltip title={this.renderPopoverContent(c3[0],c3[1],c3_text,class_name3[2], c3_type)}>
            <svg viewBox="0 0 36 36" className={class_name3[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c3_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="16.35" className={class_name3[1]}>{c3_array[0] + '%'}</text>
              <text x="18" y="20.35" className="percentage-text">{c3_text}</text>
            </svg>
            </Tooltip>
            </a>
          </div>
          }
          {isNaN(c4_percent) ?
          <div className="single-chart">
            <Tooltip title={this.renderPopoverContentNoData(no_data)}>
            <svg viewBox="0 0 36 36" className={class_name4[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c4_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="20.35" className="percentage-text" style={{fill: '#9CA3AF'}}>{c4_no_text}</text>
            </svg>
            </Tooltip>
          </div>
          :
          <div className="single-chart">
            <a>
            <Tooltip title={this.renderPopoverContent(c4[0],c4[1],c4_text,class_name4[2], c4_type)}>
            <svg viewBox="0 0 36 36" className={class_name4[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c4_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="16.35" className={class_name4[1]}>{c4_array[0] + '%'}</text>
              <text x="18" y="20.35" className="percentage-text">{c4_text}</text>
            </svg>
            </Tooltip>
            </a>
          </div>
          }
          { c5[0] === 'condition' ? <div></div> :
          <div className="single-chart">
            {isNaN(c5_percent) ?
            <a>
            <Tooltip title={this.renderPopoverContentNoData(no_data)}>
            <svg viewBox="0 0 36 36" className={class_name5[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c5_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="20.35" className="percentage-text" style={{fill: '#9CA3AF'}}>{c5_no_text}</text>
            </svg>
            </Tooltip>
            </a>
            :
            <a>
            <Tooltip title={this.renderPopoverContent(c5[0],c5[1],c5_text,class_name5[2], c5_type)}>
            <svg viewBox="0 0 36 36" className={class_name5[0]}>
              <path className="circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path className="circle"
                strokeDasharray={c5_array}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="16.35" className={class_name5[1]}>{c5_array[0] + '%'}</text>
              <text x="18" y="20.35" className="percentage-text">{c5_text}</text>
            </svg>
            </Tooltip>
            </a>
            }
          </div>
          }
        </div>
      </div>
    )
  }

  renderLifeStyle(){
    let that = this
    return(
      <div>
        {this.renderSvgCircleProgress(that.state.data.stress,that.state.data.smoking,
                                      that.state.data.alcohol,that.state.data.diet,
                                      that.state.data.exercise,
                                      "Have High Stress","Smokes Frequently",
                                      "Drinks Frequently","Have Bad Diet",
                                      "Never Exercise","No Stress Data","No Smoking Data","No Alcohol Data","No Diet Data","No Exercise Data","The data hasn’t been provided yet, encourage employees to take HRA to show the results.",
                                      'stress', 'smoke', 'alcohol', 'diet', 'exercise')}
        <Row type="flex" justify="start" style={{marginLeft: 12,marginTop: 15}}>
          <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0,marginTop: 7}}>DETAILED LIFESTYLE ANALYSIS</h4>
        </Row>

          <Tabs defaultActiveKey="1">
            <TabPane tab="Stress" key="1">
              <Stress contractId = {this.state.contractId} startDate = {this.state.startDate} endDate = {this.state.endDate}/>
            </TabPane>
            <TabPane tab="Smoking" key="2">
              <Smoking contractId = {this.state.contractId} startDate = {this.state.startDate} endDate = {this.state.endDate}/>
            </TabPane>
            <TabPane tab="Alcohol" key="3">
              <Alcohol contractId = {this.state.contractId} startDate = {this.state.startDate} endDate = {this.state.endDate}/>
            </TabPane>
            <TabPane tab="Diet" key="4">
              <Diet contractId = {this.state.contractId} startDate = {this.state.startDate} endDate = {this.state.endDate}/>
            </TabPane>
            <TabPane tab="Exercise" key="5">
              <Exercise contractId = {this.state.contractId} startDate = {this.state.startDate} endDate = {this.state.endDate}/>
            </TabPane>
          </Tabs>

      </div>
    )
  }

  renderConditions(){
    let that = this
    return(
      <div>
        {this.renderSvgCircleProgress(that.state.data.hypertension,that.state.data.diabetes,
                                      that.state.data.cvd,that.state.data.weight,["condition",0],
                                      "are Hypertensive","are Diabetic",
                                      "Have High CVD Risk","are Obese","","No Hypertensive Data","No Diabetic Data","No CVD Data","No Obese Data","","The data hasn’t been provided yet, encourage employees to take health checks to show the results.",
                                      'hypertension', 'diabetic', 'cvd', 'obese')}
        <Row type="flex" justify="start" style={{marginLeft: 12,marginTop: 15}}>
          <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0,marginTop: 7}}>DETAILED CONDITION ANALYSIS</h4>
        </Row>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Hypertensive" key="1">
            <Hypertensive contractId = {this.state.contractId} startDate = {this.state.startDate} endDate = {this.state.endDate}/>
          </TabPane>
          <TabPane tab="Diabetic" key="2">
            <Diabetic contractId = {this.state.contractId} startDate = {this.state.startDate} endDate = {this.state.endDate}/>
          </TabPane>
          <TabPane tab="CVD" key="3">
            <Cvd contractId = {this.state.contractId} startDate = {this.state.startDate} endDate = {this.state.endDate}/>
          </TabPane>
          <TabPane tab="Obese" key="4">
            <Weight contractId = {this.state.contractId} startDate = {this.state.startDate} endDate = {this.state.endDate}/>
          </TabPane>
        </Tabs>
      </div>
    )
  }

  getTheText = (id, data) =>{
    let tab = data.find(item => item.contract_id === id)
    return tab.text ;
  }
  render () {
    let that = this
    let {metricObj} = that.state
    const formattedData = metricObj ? metricObj.formattedData : null;

      return (
        <div>
        {(that.state.loading || Object.keys(that.state.data).length === 0 )? <div className="spiner">
          <Spin size="large"/>
        </div> :
        <div>
           <Modal
              visible={that.state.showModal}
              icon={greenTickThick}
              heading='Request received'
              body={`Dear ${sessionStorage.getItem(
                'hr_name'
              )}, the requested data will be sent to you on your email id within an hour.`}
              handler={() => this.setState({ showModal: false })}
            />
          <Row>
            <Breadcrumb
              list={[
                { text: 'Analytics', link: '#' },
                { text: 'Health risks', link: '/health-risks' },
              ]}
              classes='mb-2'
            />
          </Row>
          <Row type="flex" justify='space-between'>
            <Col>
              <Row type="flex" justify="start">
                <h2 className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl my-0'>Health Risk Assessment (HRA)</h2>
              </Row>
              <Row>
              <p className='text-gray-500 mt-1.5 mb-0 leading-4 text-sm'>Insights on lifestyle choices that influence health</p>
              </Row>
            </Col>
            <Col>
              <button
                onClick={this.downloadHra}
                className={joinButtonClasses(dsButtonPrimary, 'h-9 w-40 px-2 whitespace-nowrap')}>
                <img src={download_btn} className='mr-2' style={{ width: 14}} />
                Download HRA
              </button>
            </Col>
          </Row>
          <Row>
            <Tabbar
              list={formattedData}
              loading={true}
              classes='mt-5'
              currentPage={this.getTheText(this.state.contractId, formattedData)}
              setContract={this.changeContractId}
            />
          </Row>
          { that.state.tabLoading ?
              <div className="spiner">
                <Spin size="large"/>
              </div>
            :
              <div>
              <Row>
                <Col span={12}>
                  <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 15}}>
                    <img src={SingleHeartImage}/>
                    <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0,marginTop: 7}}>BASED ON</h4>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row type="flex" justify="end" style={{paddingRight: 0,marginTop: 5}}>
                    <h4 className="top-right-delay-label" style={{marginTop: 10}}>Refreshes every <b> 1 hour </b></h4>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Tabs defaultActiveKey="1">
                  <TabPane tab="Lifestyle" key="1">
                    {this.renderLifeStyle()}
                  </TabPane>
                  <TabPane tab="Conditions" key="2">
                    {this.renderConditions()}
                  </TabPane>
                </Tabs>
              </Row>
            </div>
          }
        </div>}
        </div>
      )
  }
}
export default HealthRisks;
